import Stack from '@mui/material/Stack'
import useCheckFiles from 'components/Mobile/hooks/useCheckFiles'
import SendButton from 'components/Mobile/SendButton'
import UploadDialog, { DialogStatus } from 'components/Mobile/UploadDialog'
import UploadFields from 'components/Mobile/UploadFields'
import useDocUpload from 'hooks/useDocUpload'
import { useState } from 'react'

const UploadPage = () => {
  const { onSendMobile, files, reset, ...rest } = useDocUpload('normal')
  const checkFiles = useCheckFiles()

  const [dialogStatus, setDialogStatus] = useState<DialogStatus>('close')
  const handleClick = () => {
    checkFiles(files) && setDialogStatus('confirm')
  }

  return (
    <Stack component="main" sx={{ overflow: 'hidden', flex: 1 }}>
      <UploadFields files={files} {...rest} />
      <SendButton onClick={handleClick} disabled={files.length === 0} />
      <UploadDialog
        state={dialogStatus}
        setStatus={setDialogStatus}
        onSend={onSendMobile}
        confirmAPILimit={rest.confirmAPILimit}
        reset={reset}
      />
    </Stack>
  )
}

export default UploadPage
